module.exports = __webpack_public_path__ + "_assets/img/01.1aafff4d.png";